module.exports = __webpack_public_path__ + "static/N2N1-a71f290bf4f26487c6ed97943d426431.jpg";